import { Chip } from '../../chip';
import { Text } from '../../text/text.component';
import { TextLink } from '../../text-link/text-link.component';
import { ListFieldItemStyles } from './list-field-item.styles';

type Props = {
  children: React.ReactNode;
  disabled?: boolean;
  onRemove: () => void;
};

export const ListFieldItem = ({ children, disabled, onRemove }: Props) => {
  return (
    <li className={ListFieldItemStyles.listFieldItem}>
      <Text className={ListFieldItemStyles.itemText}>{children}</Text>
      {!disabled && (
        <TextLink color='error' onClick={onRemove}>
          Remove
        </TextLink>
      )}
    </li>
  );
};

export const ListFieldItemBadge = ({ children, disabled, onRemove }: Props) => {
  return (
    <li>
      <Chip.Removable disabled={disabled} onClick={onRemove}>
        {children}
      </Chip.Removable>
    </li>
  );
};
